import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { motion } from 'framer-motion';
import 'react-toastify/dist/ReactToastify.css';

const TaxInfoForm = () => {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    const filePath = '/ADSPACE TAX FORM 2025.pdf';
    const currentYear = new Date().getFullYear();
    const link = document.createElement('a');
    link.href = filePath;
    link.download = `ADSPACE TAX FORM ${currentYear}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    toast.success(`Tax form ${currentYear} downloaded!`);
  };

  return (
    <>
      <ToastContainer />

      <motion.div
        className="bg-white p-6 rounded-xl shadow-md max-w-xl mx-auto"
        data-aos="fade-up"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">
          Manage Tax Information
        </h2>

        <p className="mb-5 text-sm text-gray-600 leading-relaxed">
          This information is required to determine whether you're a U.S. or non-U.S. taxpayer. It helps us comply with tax regulations and determine if withholding applies to your income.
        </p>

        <button
          onClick={handleDownload}
          disabled={loading}
          className={`w-full md:w-auto inline-flex items-center justify-center px-5 py-2.5 rounded-md text-sm font-medium transition-all duration-300
            ${loading
              ? 'bg-red-300 text-white cursor-not-allowed'
              : 'text-red-500 border border-red-500 hover:bg-red-500 hover:text-white'
            }`}
        >
          {loading ? 'Preparing...' : 'Download Tax Info'}
        </button>
      </motion.div>
    </>
  );
};

export default TaxInfoForm;
